import {
  BatchTrcBooksAndAvRegConditionListItem,
  BatchTrcBooksAndAvRegConditionListItemFromJSON
} from '@/api/models/batch/BatchTrcBooksAndAVRegConditionListItem'

export interface BatchTrcBooksAndAvRegPageLoadResult {
  items: BatchTrcBooksAndAvRegConditionListItem
}

export function BatchTrcBooksAndAvRegPageLoadResultFromJSON(
  json: any
): BatchTrcBooksAndAvRegPageLoadResult {
  return {
    items: BatchTrcBooksAndAvRegConditionListItemFromJSON(json)
  }
}
